import * as React from 'react';
import classNames from 'classnames';
import './navigationLoginButton.module.scss';

type Props = {
    onClick?: () => any;
    withBorder?: boolean;
    children: any;
    className?: string;
    styleName?: string;
};

export const LoginButton = ({ onClick, children, withBorder, className }: Props) => {
    return (
        <div
            id="login-button"
            styleName={classNames('login-button', { 'with-border': withBorder })}
            onClick={onClick}
            className={className}
        >
            {children}
        </div>
    );
};

export const NavigationLoginButton = ({ onClick, children, withBorder, className }: Props) => {
    return (
        <div
            id="login-button"
            styleName={classNames('navigation-login-button', { 'with-border': withBorder })}
            onClick={onClick}
            className={className}
        >
            {children}
        </div>
    );
};
